import defaultRisks from "@/assets/data/json_output/risks.json";
import defaultSignals from "@/assets/data/json_output/signals.json";
import clarioRisks from "@/assets/data/json_output/clario/risks.json";
import clarioSignals from "@/assets/data/json_output/clario/signals.json";
import { getTenantSlug } from "@/views/PortfolioConnections/portfolioConnectionsConfig";
import type { RiskTableRow } from "@/views/Risk/Risks/risksTableConfig";
import type { SignalTableRow } from "@/views/Risk/Signals/utils";

/**
 * The RBQM risk and signal registers are static per-tenant datasets, so a
 * tenant with its own register gets an entry here; everyone else keeps the
 * shared default. Selected once at module load — the datasets never change at
 * runtime, and the hostname can't change without a reload.
 *
 * Breaches and tasks are deliberately NOT tenant-scoped: they still come from
 * the shared breaches-issues.json / tasks.json.
 */
type RiskRegister = {
  risks: RiskTableRow[];
  signals: SignalTableRow[];
};

const TENANT_REGISTERS: Record<string, RiskRegister> = {
  clario: {
    risks: clarioRisks as RiskTableRow[],
    signals: clarioSignals as SignalTableRow[],
  },
};

const DEFAULT_REGISTER: RiskRegister = {
  risks: defaultRisks as RiskTableRow[],
  signals: defaultSignals as SignalTableRow[],
};

const register =
  TENANT_REGISTERS[getTenantSlug(window.location.hostname)] ?? DEFAULT_REGISTER;

export const registerRisks = register.risks;
export const registerSignals = register.signals;
